const menu = {
  key: "salesAudit",
  route: "/sales/audit",
  label: "sidebar.salesAudit",
  permission: "sales.audit.read",
  icon: "faHistory",
  group: "sales",
  order: 23
};

export default menu;
